import {css} from 'lit';
export const styles = css`inflow{color:#75b798}outflow{color:#ea868f}overall{color:#6683d5}real{color:#6683d5}goal{color:#6c757d}`;
export default styles;
